import axios from 'axios'

export default {
    namespaced: true,
    state: {
        workflowData: {}
    },
    getters: {

    },
    mutations: {
        SET_COLLAB_WORKFLOW(state, payload) {
            state.workflowData = payload
        }
    },
    actions: {
        $sh_fetchWorkflow({commit}, payload) {
            return axios({
                url: process.env.VUE_APP_APPROVAL + '/workflows',
                method: 'get'
            })
        },
        $sh_getAllCollabThreads({commit}, payload) {
            let links = process.env.VUE_APP_COLLAB + '/collab/threads/view?target_id=' + payload.target_id
            if(payload?.dis) {
                links = links + '&discipline=' + payload.dis
            } 
            if(payload?.state) {
                links = links + '&state=' + payload.state
            }
            if(payload?.thread){
                links = links + '&thread_state=' + payload.thread
            }
            if(payload?.work_id){
                links = links + '&workflow_id=' + payload.work_id
            }
            
            console.log('get all thred link => ', payload,links);
            
            return axios({
                url: links,
                method: 'get'
            })
        }
    }
}